import BaseCheckbox from "@/components_v2/FormFields/Checkbox/BaseCheckbox";
import { Option } from "@/components_v2/FormFields/Dropdown/types";
import { CheckboxGroupProps } from "@/components_v2/FormFields/Checkbox/types";

const CheckboxGroup = ({
  options,
  multiple,
  onChange,
  value,
}: CheckboxGroupProps) => {
  const handleChange = (checked: boolean, option: Option) => {
    let newValue;
    if (checked) {
      newValue = multiple
        ? [...(value as (string | number)[]), option.value]
        : option.value;
    } else {
      if (multiple) {
        newValue = (value as (string | number)[]).filter(
          (item: string | number) => item !== option.value,
        );
      } else {
        newValue = null;
      }
    }
    onChange(newValue);
  };

  return options.map((option) => (
    <BaseCheckbox
      label={option.label}
      onChange={(checked) => handleChange(checked, option)}
      checked={
        multiple
          ? Array.isArray(value) && value.includes(option.value)
          : value === option.value
      }
      key={option.value}
    />
  ));
};

export default CheckboxGroup;
